import { render, staticRenderFns } from "./EditStaff.vue?vue&type=template&id=c68234b4&scoped=true&"
import script from "./EditStaff.vue?vue&type=script&lang=js&"
export * from "./EditStaff.vue?vue&type=script&lang=js&"
import style0 from "./EditStaff.vue?vue&type=style&index=0&id=c68234b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c68234b4",
  null
  
)

export default component.exports